"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigsRoutes = void 0;
const base_1 = require("../base");
const constants_1 = require("../constants");
/**
 * API routes for Configs
 */
class ConfigsRoutes extends base_1.ApiBase {
    /**
     * Get list of active Twitch bot channels from service configuration
     * @returns Promise resolving to array of active channels
     * @throws Error if the API request fails or service is not authenticated
     */
    async getActiveTwitchBotChannels() {
        return this.apiGet(`${constants_1.ROUTES.CONFIGS}/twitch/activeChannels`);
    }
}
exports.ConfigsRoutes = ConfigsRoutes;
//# sourceMappingURL=configs.js.map